import { createServiceStore } from 'common/store';
import { initialState } from './constants';
export var useSupportRequestTypesStore = createServiceStore({
    initialValues: initialState,
});
